import React, { Component } from 'react';
import exportFromJSON from 'export-from-json';
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useAuth from '../../hooks/useAuth';
import { useNavigate,Link,Location, useLocation } from 'react-router-dom';

const LocationSelectionPage = () => {

  const { auth, setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleChangodarClick = () => {
    
    let roles = auth.roles
    let accessToken = auth.accessToken
    let expiration = auth.expiration
    let selectedLocation = "Changodar"

    setAuth({roles,accessToken,expiration,selectedLocation});

    if(roles.includes('Administrator'))
    {
      navigate('/approve', {replace:true})
    }
    else if(roles.includes('Common'))
    {
      navigate('/inventoryRequest', {replace:true})
    } 
    else 
    {
      navigate(from, {replace:true})
    }
  };

  const handleSanandClick = () => {
    let roles = auth.roles
    let accessToken = auth.accessToken
    let expiration = auth.expiration
    let selectedLocation = "Sanand"

    setAuth({roles,accessToken,expiration,selectedLocation});
    
    if(roles.includes('Administrator'))
      {
        navigate('/approve', {replace:true})
      }
      else if(roles.includes('Common'))
      {
        navigate('/inventoryRequest', {replace:true})
      } 
      else 
      {
        navigate(from, {replace:true})
      }
  };

  return (
    <div className="image-container">
      <div className="image-wrapper" onClick={handleChangodarClick}>
        <img
          src="images/Changodar.jpeg"
          alt="Image 1"
          className="image"
        />
        <div className="overlay-text">Changodar</div>
      </div>
      <div className="image-wrapper" onClick={handleSanandClick}>
        <img
          src="images/Sanand.jpeg"
          alt="Image 2"
          className="image"
        />
        <div className="overlay-text">Sanand</div>
      </div>
    </div>
  );
}

export default LocationSelectionPage;